import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  widthValue?: number;
  labelColor?: string;
  rowValue?: boolean;
  fontFamilyValue?: string;
}

export const Root = styled.div`
  z-index: 300;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.45);
  font-family: Roboto;
`

export const BoxContainer = styled.div`
  position: relative;
  width: ${(props: IRootProps) => (props.widthValue ?? 822)}px;
  height: calc(100vh - 120px - 86px);
  padding: 0px 0px 86px 0px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-radius: 6px;
`

export const TitleContainer = styled.div`
  height: 96px;
  padding: 0px 60px 0px 60px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #272727;
  background-color: rgba(18, 36, 66, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const LeftSide = styled.div`
`

export const Title = styled.div`
  padding: 0px 0px 11px 0px;
  text-transform: capitalize;
`

export const SubtitleContainer = styled.div`
  display: flex;
`


export const Content = styled.div`
  height: calc(100% - 140px);
  overflow-y: scroll;
  padding: 24px 60px;
`
export const Description = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  margin-bottom: 47px;
`;

export const LoadContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Container = styled.div`
  display: flex;
  text-align: left;
`;

export const Images = styled.div`
  display: inline-block;
  width: 144px;
  height: 147px;
  padding: 10px 0px;
  text-align: center;
`;

export const ImgContainer = styled.img`
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUAQMAAAC3R49OAAAABlBMVEX////09PQtDxrOAAAAE0lEQVQI12P4f4CBKMxg/4EYDAAFkR1NiYvv7QAAAABJRU5ErkJggg==');
	background-image: linear-gradient(45deg, $color 25%, transparent 25%), linear-gradient(-45deg, $color 25%, transparent 25%), linear-gradient(45deg, transparent 75%, $color 75%), linear-gradient(-45deg, transparent 75%, $color 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
`;

export const TextInfo = styled.div`
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8891a0;
  margin-top: 14px;
  margin-bottom: 7px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 144px;
`;

export const FileSizeSingleImg = styled.div`
  padding: 0px 0px 0px 00px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8891a0;
  white-space: nowrap;
`

export const ActionsContainer = styled.div`
  position: absolute;
  display: flex;
  right: 60px;
  bottom: 48px;
`

export const Error = styled.div`
  font-weight: bold;
  margin-right: 6px;
`

export const Action = styled.div`
  min-width: 112px;
`

export const FieldsContainer = styled.div`
  width: ${(props: IRootProps) => (props.rowValue ?  `100%` : `auto`)};
  display: ${(props: IRootProps) => (props.rowValue ?  `flex` : `auto`)};
  justify-content: ${(props: IRootProps) => (props.rowValue ?  `space-between` : `auto`)};
  flex-wrap: ${(props: IRootProps) => (props.rowValue ?  `wrap` : `auto`)};
`

export const InputsContainer = styled.div`
`;

export const LeftSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const FilesContainer = styled.div`
  width: 250px;
  height: 280px;
  overflow: auto;
  padding: 15px 19px 15px 19px;
  border-radius: 5px;
  border: solid 1px #8d8d8d;
`

export const FilesNumberMessage = styled.span`
  padding: 9px 9px 0px 0px;
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #8891a0;
`

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
`

export const FileTitle = styled.div`
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8891a0;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 45%;
`

export const FileSize = styled.div`
  padding: 0px 0px 0px 10px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8891a0;
  white-space: nowrap;
`

export const InfoContainer = styled.div`
  width: 55%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const FilePreviewContainer = styled.div`
  position: fixed;
  right: ${window.innerWidth/2}px;
  display: none;
  border-radius: 5px;
  z-index: 5;
  background-color: ${C.DARKER_GRAY};
  padding: 12px;
  ${FileRow}:hover & {
    display: block;
  }
`

export const FilePreview = styled.img`
  width: 118px;
  height: 78px;
  object-fit: cover;
  border-radius: 5px;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUAQMAAAC3R49OAAAABlBMVEX////09PQtDxrOAAAAE0lEQVQI12P4f4CBKMxg/4EYDAAFkR1NiYvv7QAAAABJRU5ErkJggg==');
	background-image: linear-gradient(45deg, $color 25%, transparent 25%), linear-gradient(-45deg, $color 25%, transparent 25%), linear-gradient(45deg, transparent 75%, $color 75%), linear-gradient(-45deg, transparent 75%, $color 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 38px;
`

export const Font = styled.div`
  margin-top: 38px;
  width: 220px;
  height: 48px;
  border-radius: 5px;
  background-color: rgba(32, 64, 120, 0.1);
  padding: 10px;
  box-sizing: border-box;
  display: block;
  align-items: center;
  justify-content: center;
  font-family: ${(props: IRootProps) => (props.fontFamilyValue ?? '')}, Roboto;
  text-align: center;
  vertical-align: middle;
  line-height: 28px;
  color: ${C.DARK_BLUE};
  word-break: auto;
  font-size: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${C.DARK_BLUE};
  word-break: auto;
  &:hover {
    display: flex;
    word-break: break-word;
    white-space: normal;
  }
  box-shadow: 4px 4px 10px 0 rgba(0, 0, 0, 0.15);
  background-color: rgba(32, 64, 120, 0.1);
`;